var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBadge = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.49998 0C0.947708 0 0.5 0.429757 0.5 0.95989V6.80647H0.509064C0.503211 6.89151 0.500238 6.97798 0.500238 7.06588C0.500257 10.3877 5.57733 12.6382 6.39078 12.9774C6.463 13.0075 6.53724 13.0075 6.60946 12.9774C7.42291 12.6382 12.5 10.3877 12.5 7.06588C12.5 6.97803 12.4968 6.89156 12.4906 6.80647H12.4998V0.95989C12.4998 0.429757 12.0521 0 11.4998 0H1.49998ZM4.17214 4.72997C4.23104 4.67343 4.32653 4.67343 4.38543 4.72997L5.81541 6.10261L8.60678 3.42316C8.66568 3.36662 8.76117 3.36662 8.82007 3.42316L9.64574 4.21572C9.70464 4.27226 9.70464 4.36392 9.64574 4.42046L6.81237 7.14023C6.80812 7.17059 6.79384 7.19989 6.76954 7.22322L5.94387 8.01579C5.88497 8.07232 5.78948 8.07232 5.73058 8.01579L3.34647 5.72727C3.28757 5.67073 3.28757 5.57907 3.34647 5.52253L4.17214 4.72997Z",
    fill: "#B2BCEB"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBadge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/badge.ed3ccf30bf5a91ed3a86eb445aa04e51.svg";